import script from "./TabsFerramentaGrupo.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsFerramentaGrupo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
